import { Component, OnInit} from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { SignupService } from '../services/signup.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-salesactivity',
  templateUrl: './salesactivity.component.html',
  styleUrls: ['./salesactivity.component.css']
})
export class SalesactivityComponent implements OnInit {
  Msg;
  RespMsg;
  reaponse;
  Feed;
  statuss;
  formR: FormGroup;
  formD: FormGroup;
  formC: FormGroup;
  public temp: Object=false;
  public empData: Object;
  constructor(private formBuilder: FormBuilder,private Signup : SignupService,private router: Router) { }

  ngOnInit() {
  this.LoadData();
  this.reaponse='';
  this.InitSourceUpdate();
  this.InitSourceRemove();
  this.InitCreateForm();
  }
  
  LoadData() {
    this.Signup.GetSalesActivity(localStorage.getItem('usertype'),localStorage.getItem('Userid')).subscribe((resData) => {
     //console.log(resData.code);
      if(resData['code']==1){
      this.empData= resData['SalesActivity'];
      this.temp = true;
     } else {
      this.empData= "";  
     }
      
    })
  }
  onSourceDetails(eid){
    this.RespMsg =null;
    this.Msg =null;
    const postData = new FormData();
    postData.append('id', eid);
    this.Signup.SalesActivityDetails(postData).subscribe(
      (res:any) => {
        this.reaponse=res;
        this.InitSourceUpdate();
      }
    );
  }
  InitSourceUpdate()
  { 
    
    this.formR = this.formBuilder.group({
      activity:[this.reaponse.activity,Validators.required],
      status:[this.reaponse.status,]
    });
   
  }
  onUpdateLeadType(clientData,lid)
  {
    this.Msg ='Wait';
    const postDataS = new FormData();
    postDataS.append('activity', clientData.activity);
    postDataS.append('status', clientData.status);
    postDataS.append('lid', lid);
    this.Signup.SalesUpdateActivity(postDataS).subscribe(
      (res:any) => {
        this.RespMsg =res.msg;
        console.log(res);
        if(res.code==1){        
          this.Msg =res.msg;
         // console.log(res);
          this.LoadData();
        }
        this.Msg ='';
      }
    );  
  }
  onRemoveDetails(eid){
    this.RespMsg =null;
    this.Msg =null;
        this.reaponse=eid;
        //console.log(eid); 
  }
  InitSourceRemove()
  {
    this.formD = this.formBuilder.group({
      leadid:[this.reaponse.id,],
      types:['Source',]
    });
  }
  onRemoveSource(clientData){
    this.temp = false; 
    this.Msg ='Wait';
    const postDataR = new FormData();
    postDataR.append('tables','Activity');
    postDataR.append('lid',clientData);
    this.Signup.DataRemoveActivitys(postDataR).subscribe(
      (res:any) => {
        this.RespMsg =res.msg;
        //console.log(res);
        if(res.code==1){        
          this.Msg =res.msg;
          this.LoadData();
        }
        this.Msg ='';
      }
      );
  }

  InitCreateForm()
  {
    this.formC = this.formBuilder.group({
      activity:['', Validators.required],
      status:['Active',]
    });
  }
  onCreateLeadType(clientData)
  {
    this.temp = false; 
    this.Msg ='Wait';
    //console.log(clientData);
    const formData = new FormData();
    formData.append('activity', clientData.activity);
    formData.append('status', clientData.status);
    formData.append('id', localStorage.getItem("Userid"));
    formData.append('Usertype',  localStorage.getItem("usertype"));
    this.Signup.CreateSalesActivity(formData).subscribe(
      (res:any) => {
        this.RespMsg =res.msg;
        //console.log(res);
        this.InitCreateForm();
        if(res.code==1){
          this.Msg =res.msg;
          this.LoadData();
        }
        this.Msg ='';
      }
    );  
  }
}
